<template>
	<div class="watermark">
        <img :src="logoURL"/>
	</div>
</template>

<style>
.watermark {
	z-index: 3;
	position: absolute;
	bottom: 10px;
	left: 10px;
	pointer-events: none;
	width: 200px;
	height: auto;
	filter: drop-shadow(0px 0px 6px rgba(0,0,0,0.2));
}

/*MOBILE*/
@media (max-device-width: 900px){
	.watermark{
		display: none;
	}
}
@media (max-width: 1600px){
	.watermark{
		display: none;
	}
}
</style>

<script>
import {mapGetters} from 'vuex';

export default {
	computed: {
		...mapGetters(['logoURL']),
	}
}

</script>